import React, { useState } from "react";
import { Link } from "react-router-dom";

const QA = [
  {
    q: "What is ancestral energy?",
    a: (
      <>
        <strong>Ancestral energy is stored, accumulated intention.</strong>
        <br /><br />
        It is the total force created by the lives, struggles, prayers, skills,
        desires, and will of those who came before you. Nothing disappears.
        It adds up.
      </>
    ),
  },
  {
    q: "Why does quantity matter in spiritual power?",
    a: (
      <>
        Power comes from accumulation.
        <br /><br />
        Food sustains because it is stored. Water nourishes because it gathers.
        Strength, wealth, wisdom, and influence all grow through quantity.
        Spiritual energy follows the same law.
      </>
    ),
  },
  {
    q: "What is the difference between a particle and a field?",
    a: (
      <>
        A <strong>particle</strong> acts alone and fades quickly.
        <br />
        A <strong>field</strong> influences everything within it.
        <br /><br />
        A single thought is fragile. A field of repeated intention becomes force.
        Ancestral energy is not a moment, it is a field built over generations.
      </>
    ),
  },
  {
    q: "How do African traditions understand ancestral energy?",
    a: (
      <>
        In African spiritual systems, ancestors are not memories, they are
        <strong> active reservoirs</strong>.
        <br /><br />
        They form a living field of protection, guidance, survival, and momentum.
        Rituals, libations, names, and remembrance are not symbolic,
        they are methods of access.
        <br /><br />
        One ancestor offers guidance.
        <br />
        Many create protection.
        <br />
        Thousands create momentum.
      </>
    ),
  },
  {
    q: "Is this idea found in other traditions?",
    a: (
      <>
        Yes. Across cultures, the same truth appears.
        <br /><br />
        Carl Jung described a shared psychic field beyond the individual,
        what he called the <em>collective unconscious</em>.
        <br /><br />
        Christianity echoes the same principle:
        <br /><br />
        <em>“The sins of the fathers…”</em>
        <br />
        <em>“…and blessings unto the thousandth generation.”</em>
        <br /><br />
        This acknowledges that spiritual momentum moves through bloodlines,
        stored, inherited, and activated.
      </>
    ),
  },
  {
    q: "What are egregores?",
    a: (
      <>
        Egregores are collective thought-forms that grow stronger the more
        they are fed.
        <br /><br />
        Ancestral energy pools are egregores rooted not in imagination,
        but in history, blood, and lived reality.
      </>
    ),
  },
  {
    q: "Why do ancestral energy pools matter?",
    a: (
      <>
        Because you are not meant to start from zero.
        <br /><br />
        Manifestation fails when the energy behind desire is thin.
        Ancestral energy is not thin.
        <br /><br />
        It is deep. Vast. And already behind you.
      </>
    ),
  },
  {
    q: "What does AncestralPool help you do?",
    a: (
      <>
        AncestralPool helps you see the readily available pool of manifestation and intention that already exists and is available to you.
      </>
    ),
  },
  {
  q: "What does the visualization mean?",
  a: (
    <>
      The visualization shows your ancestors or how many of your ancestors were able to successfully express,
      embody, or manifest a similar capacity, trait, or outcome.
      <br /><br />
      Each layer reflects depth: 
      <br />
      • Top 10%: Those who were great at manifesting this thing. 
      <br />
      • Top 1%: These are the best of the best. Those who manifested this trait exceptionally.  
      <br /><br />
      The deeper the pool, the less effort is required for you to step into
      the same current.
    </>
  ),
},
{
  q: "How is the visualization calculated?",
  a: (
    <>
      The visualization is calculated through <strong>probability modeling</strong>,
      and inferencing where no statistical result is present.
      <br /><br />
        It uses some assumptions for example, It assumes the total number of ancestors each person has had is 130,000,000. This can be logically proven.
      The predictions are not meant to be scientifically accurate; It's designed to be logical.
    </>
  ),
},
{
  q: "Are all the numbers in the visualization scientifically backed?",
  a: (
    <>
      Not all numbers are strictly scientific and they are not meant to be.
      <br /><br />
      Where scientific data exists (psychology, behavior, population traits),
      it is used.
      <br /><br />
      Where science ends, the system responsibly incorporates
      <strong>historical, anthropological, and spiritual frameworks</strong>
      that humans have relied on for thousands of years.
      <br /><br />
      This is not a claim of genetic accuracy.
      <br />
      It is a logical model of <strong> energetic likelihoods and accumulated precedent</strong>.
      <br /><br />
      Think of it as a map, not a guarantee.
    </>
  ),
},
];

export default function AboutEnergyPools() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div
      style={{
        maxWidth: "720px",
        margin: "0 auto",
        padding: "24px 20px 80px",
        lineHeight: 1.7,
        color: "#1f2937",
      }}
    >
      {/* Back Button */}
      <Link
        to="/"
        style={{
          display: "inline-block",
          marginBottom: "24px",
          textDecoration: "none",
          fontSize: "14px",
          fontWeight: 600,
          color: "#066201ff",
        }}
      >
        ← Back to Home
      </Link>

      {/* Title */}
      <h1
        style={{
          fontSize: "28px",
          fontWeight: 800,
          letterSpacing: "-0.6px",
          marginBottom: "24px",
        }}
      >
        About Energy Pools
      </h1>

      {/* Closing */}
      <p
        style={{
          marginTop: "40px",
          marginBottom:"30px",
          fontSize: "14px",
          fontWeight: 400,
          color: "#111827",
        }}
      >
        "A single footpath is not found.
        But a path walked by many becomes a road.”
        - African Proverb
                                   
      </p>

      {/* Q&A */}
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {QA.map((item, i) => {
          const open = openIndex === i;

          return (
            <div
              key={i}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                padding: "16px",
                background: open ? "#f9fafb" : "white",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onClick={() => setOpenIndex(open ? null : i)}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {item.q}
                <span style={{ fontSize: "18px", opacity: 0.6 }}>
                  {open ? "−" : "+"}
                </span>
              </div>

              {open && (
                <div
                  style={{
                    marginTop: "12px",
                    fontSize: "15px",
                    color: "#374151",
                  }}
                >
                  {item.a}
                </div>
              )}
            </div>
          );
        })}
      </div>

      
    </div>
  );
}
